export default __webpack_public_path__ + "static/media/imgContacts.da3a363c.jpg";